import Hero from "../components/Hero";
import AboutSection from "../components/AboutSection";
import ProcessSection from "../components/ProcessSection";
import WhyChooseSection from "../components/WhyChooseSection";
import FaqsSection from "../components/FaqsSection";
import SocialSection from "../components/SocialSection";
import CtaBanner from "../components/CtaBanner";
import PricingSection from "../components/PricingSection";

export default function Home() {
  return (
    <>
      <Hero />
      <AboutSection />
      <WhyChooseSection />
      <ProcessSection />
      <PricingSection />
      <FaqsSection />
      <SocialSection />
      <CtaBanner />
    </>
  );
}
